// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1RrrU","header":"ClearentDisclaimer_header__34cQA","inner":"ClearentDisclaimer_inner__1fx7M"};